/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import _forEach from 'lodash/forEach';
import bnd3Service from '../../../services/bnd3.service';
import utilityService from '../../../services/utility.service';
import ChartConst from '../../../constants/chart.constant';
import AppConst from '../../../constants/app.constant';
import WeatherConst from '../../../constants/weather.constant';
import bnChartDataService from '../../../services/chartData.service';
import d3 from '../../../globalexports/d3.export';

function xAxisMeteogramService() {
  const content = {};
  content.drawXaxis = (
    sourceData,
    flightRuleStrip,
    flightWeatherStrip,
    flightWeatherStripHeight,
    temperatureStripHeight,
    hideBottomAxis,
    chartObj,
    width,
    topSpace,
    x,
    yAxisRectWidth,
    yAxisRightRectWidth,
    ceilingChartHeight,
    ceilingChartY,
    dateFormat,
    dateFormat2,
    settings,
    flightDots,
    majorContainerHeight,
    xAxisTopContainerHeight,
    xAxisBottomContainerHeight,
    isTopAxis,
  ) => {
    const normalTextHeight = bnd3Service.getSelectionHeight(d3.select('#bntextrefmeteo'));
    const zeroZuluLineData = [];
    const flightRuleStripHeight = (flightDots.radius * 2) + (flightDots.strokeWidth * 2) + 2;
    // var questionMarkHeight = parseFloat(d3.select("#bntextrefmeteo").style("font-size"));
    if (!sourceData) {
      return;
    }
    const zeroZuluContainer = chartObj.append('g')
      .attr('id', 'zero-zulu-container');

    // Drawing ceiling background here so that Zero Zulu
    // lines are not covered by blue background of ceiling
    chartObj.append('g')
      .attr('class', 'ceiling-background')
      .append('rect')
      .attr('x', yAxisRectWidth)
      .attr('y', ceilingChartY - normalTextHeight)
      .attr('width', width - (yAxisRectWidth + yAxisRightRectWidth))
      .attr('height', ceilingChartHeight)
      .attr('fill', ChartConst.ceilingAreaBackgroundColor);
    const data = sourceData.forecast;
    const sourceForDateStrip = {
      uniqueDays: [],
      sourceData: [],
      zeroLineSource: [],
    };
    // var temp = utilityService.clone(data);
    _forEach(data, (obj) => {
      const airport = utilityService.clone(obj);
      if (sourceForDateStrip.uniqueDays.indexOf(dateFormat2(airport.forecast_ts)) < 0) {
        const temp = {
          display: dateFormat2(airport.forecast_ts),
          dateValue: airport.forecast_ts,
        };
        const temp2 = utilityService.clone(temp);
        if (settings.timeZone === AppConst.timeZones.local.key) {
          temp.dateValue = new Date(temp2.dateValue.setHours(0, 0, 0, 0));
        }
        sourceForDateStrip.uniqueDays.push(dateFormat2(airport.forecast_ts));
        sourceForDateStrip.sourceData.push(utilityService.clone(temp));
        // if (settings.timeZone === AppConst.timeZones.local.key) {
        //     sourceForDateStrip.zeroLineSource.push(temp2.dateValue.setHours(0, 0, 0, 0));
        // } else {
        //     //TBD: Improve this logic. Not sure why with ZULU setting hours to 0000 not working
        //     var formattedDate = dateFormat(temp2.dateValue);
        //     if (formattedDate.substring(0, 2) === "00") {
        //         var minutesLag = parseInt(formattedDate.substring(2, 4));
        //         sourceForDateStrip.zeroLineSource.push(utilityService.subtractMinutes(
        // temp2.dateValue, minutesLag));
        //     }
        // }
      }
    });

    // console.log(data);
    // return;
    // console.log(sourceForDateStrip);
    // X-Axis left side ChartConst
    const xAxis = d3.axisBottom()
      .scale(x)
      .tickFormat((d) => {
        zeroZuluLineData.push(d);
        return dateFormat(d);
      })
      .tickSizeInner(0)
      .tickSizeOuter(0)
      .tickPadding(isTopAxis
        ? (normalTextHeight / 2)
        : -((normalTextHeight / 2) + 2));

    // X-Axis left side ChartConst
    // xAxisMajor = d3.axisBottom()
    //     .scale(x)
    //     .tickFormat(function (d) {
    //         if (utilityService.covertEpochToDate(settings.timeZone, d) ===
    // ChartConst.GraphConfig.majorXaxis.middleZulu) {
    //             return dateFormat2(d);
    //         } else {
    //             return "";
    //         }
    //     })
    //     .tickSizeInner(0)
    //     .tickSizeOuter(0)
    //     .tickPadding(isTopAxis
    //         ? -(normalTextHeight / 2) - 2
    //         : ((normalTextHeight / 2) + 0));

    // Setting Domain for X-axis
    x.domain(d3.extent(data, (d) => d.forecast_ts));
    const routeMajorDates = chartObj.append('g')
      .attr('id', 'meteo-major-date-strip')
      .selectAll('majorDays')
      .data(sourceForDateStrip.sourceData)
      .enter();
    const daysRect = routeMajorDates.append('rect');
    routeMajorDates.append('text').text((d) => d.display).attr('style', 'font-weight: bold')
      .attr('id', (...args) => `meteoMajorDayText${args[1]}`)
      .attr('x', (...args) => {
        const d = args[0];
        const key = args[1];
        const lastXOfAxis = width - yAxisRightRectWidth;
        const dayStart = (key === 0
          ? 0
          : x(d.dateValue));
        let dayEnd = lastXOfAxis;
        const selfEle = utilityService.getSelfElement(args);
        const widthOfDayText = bnd3Service.getSelectionWidth(d3.select(selfEle));
        if (sourceForDateStrip.sourceData[key + 1]) {
          dayEnd = Math.min(x(sourceForDateStrip.sourceData[key + 1].dateValue), lastXOfAxis);
        }
        dayEnd -= ((key + 1) * 2);
        const availablespace = (dayEnd - dayStart);
        if (availablespace > widthOfDayText) {
          return dayStart + (availablespace - widthOfDayText) / 2;
        }
        return -200;
      })
      .attr('y', (isTopAxis
        ? -1
        : (normalTextHeight) + 2));
    daysRect.attr('height', normalTextHeight)
      .attr('x', (...args) => {
        const d = args[0];
        const key = args[1];
        const lastXOfAxis = width - yAxisRightRectWidth;
        const dayStart = (key === 0
          ? x(d.dateValue) - Math.floor(yAxisRectWidth)
          : x(d.dateValue));
        let dayEnd = lastXOfAxis;
        const selfEle = d3.select(utilityService.getSelfElement(args).parentNode);
        const widthOfDayText = bnd3Service.getSelectionWidth(selfEle.select(
          `${'#meteoMajorDayText'}${key}`,
        ));
        if (sourceForDateStrip.sourceData[key + 1]) {
          dayEnd = Math.min(x(sourceForDateStrip.sourceData[key + 1].dateValue), lastXOfAxis);
        }
        dayEnd -= ((key + 1) * 2);
        const availablespace = (dayEnd - dayStart);
        if (availablespace > widthOfDayText) {
          return (dayStart + (availablespace - widthOfDayText) / 2);
        }
        return -200;
      })
      .attr('width', (...args) => {
        const selfEle = d3.select(utilityService.getSelfElement(args).parentNode);
        const textNode = bnd3Service.getSelectionWidth(selfEle.select(
          `${'#meteoMajorDayText'}${args[1]}`,
        ));
        return textNode;
      })
      .attr('y', (isTopAxis
        ? -normalTextHeight
        : 2))
      .attr('fill', '#fff');
    const dayNightIndicator = chartObj.append('g')
      .attr('id', 'day-night-indicator-meteo')
      .attr('class', 'day-night-indicator')
      .attr('transform', () => `translate(${0},  ${isTopAxis
        ? 4
        : -normalTextHeight})`);
    chartObj.append('g')
      .attr('class', 'x-axis x-axis-minor x-axis-minor-meteo')
      .call(xAxis);

    // chartObj.append("g")
    //     .attr("class", "x-axis x-axis-major x-axis-major-meteo")
    //     .call(xAxisMajor)
    //     .selectAll(".tick");

    const daysForDayNight = bnChartDataService.getDaysInData(
      data,
      'forecast_ts',
      'forecast_ts_local',
    );

    if (isTopAxis) {
      zeroZuluContainer.selectAll('g')
        .data(zeroZuluLineData)
        .enter()
        .append('line')
        .classed('zeroLine', true)
        .attr('x1', (d) => x(d))
        .attr('y1', () => 0)
        .attr('x2', (d) => x(d))
        .attr('y2', (d) => {
          const zulu = utilityService.covertEpochToDate(settings.timeZone, d);
          let y2;
          if (zulu === ChartConst.GraphConfig.majorXaxis.verticalLineZulu) {
            y2 = majorContainerHeight - (hideBottomAxis
              ? (temperatureStripHeight + (topSpace * 2))
              : 0);
            return y2;
          }
          return 0;
        })
        .attr('transform', `translate(0, ${-((xAxisTopContainerHeight / 2) - 2)})`);

      flightRuleStrip.append('rect')
        .attr('class', 'flight-rule-rect')
        .attr('x', 0)
        .attr('y', -((flightDots.radius * 2) + (flightDots.strokeWidth * 2)
          + 2)) // Adding 2 to have some clear space
        .attr('width', width)
        .attr('height', flightRuleStripHeight); // Adding 2 to have some clear space
      const dayNightIndicatorHeight = (xAxisTopContainerHeight / 2) + flightWeatherStripHeight;
      bnd3Service.drawDayNightIndicator(
        dayNightIndicatorHeight,
        dayNightIndicator,
        x,
        width,
        daysForDayNight,
      );
      // var dayNightsTime = bnd3Service.drawDayNightIndicator(
      // dayNightIndicatorHeight, dayNightIndicator, x, width, daysForDayNight);
      // var meteoDayNightTimes = chartObj.append("g")
      //     .attr("id", "meteo-major-time-strip")
      //     .selectAll("majortimes")
      //     .data(dayNightsTime)
      //     .enter();
      // meteoDayNightTimes.append("text")
      //     .text(function (d) {
      //         return dateFormat(d);
      //     })
      //     .attr("x", function (d) {
      //         var selfEle = utilityService.getSelfElement(arguments);
      //         var widthOfDayText = bnd3Service.getSelectionWidth(d3.select(selfEle));
      //
      //         return x(d) - (widthOfDayText / 2);
      //     })
      //     .attr("y", "-1");
      const weatherConditions = flightWeatherStrip.selectAll('path')
        .data(data)
        .enter();

      weatherConditions.append('svg:image')
        .attr('width', flightWeatherStripHeight)
        .attr('y', -flightWeatherStripHeight)
        .attr('x', (d) => x(d.forecast_ts) - (flightWeatherStripHeight / 2))
        .attr('height', flightWeatherStripHeight)
        .attr('xlink:href', (d) => {
          // Keep it blank if weatherRepresentation is empty
          if (d.weatherRepresentation) {
            return utilityService.getWeatherFilePath(d.weatherRepresentation.filename);
          }
          return WeatherConst.noWeatherIcon;
        });

      const flightRule = flightRuleStrip.selectAll('path')
        .data(data)
        .enter();
      flightRule.append('path')
        .attr('fill', (d) => bnd3Service.getFlightDotColorForRruleset(d.frlServerValue || d.frl))
        .attr('stroke-width', flightDots
          .strokeWidth) // Using windSpeed.light for configuring barbs
        .attr('d', (d) => {
          d.endAngle = bnd3Service.getEndAngle(d.cld);
          // Arc to create path value for filling areas accourding to cloud
          const arc = d3.arc()
            .innerRadius(0)
            .outerRadius(flightDots.radius)
            .startAngle(0)
            .endAngle(d.endAngle)();
          return arc;
        })
        .attr('transform', (d) => {
          const xValue = x(d.forecast_ts);
          const yValue = -(flightRuleStripHeight / 2);
          return `translate(${xValue}, ${yValue})`;
        });
      flightRule.append('circle')
        .attr('cx', (d) => x(d.forecast_ts))
        .attr('Sd', 'ASdasd')
        .attr('cy', () => -(flightRuleStripHeight / 2))
        .attr('r', flightDots.radius)
        .attr('stroke', (d) => bnd3Service.getFlightDotColorForRruleset(d.frlServerValue || d
          .frl))
        .attr('stroke-width', flightDots.strokeWidth)
        .style('display', (d) => {
          if (!d.cld && bnd3Service.getFlightDotColorForRruleset(d.frlServerValue || d.frl)
            === 'gray') {
            return 'none';
          }
          return 'inherit';
        })
        .attr('fill', (d) => {
          if (!d.cld && bnd3Service.getFlightDotColorForRruleset(d.frlServerValue || d.frl)
            === 'gray') {
            return bnd3Service.getFlightDotColorForRruleset(d.frlServerValue || d.frl);
          }
          return 'none';
        });
      const questionWidth = (flightDots.radius * 2) + (flightDots.strokeWidth);
      flightRule.append('svg:image')
        .attr('y', () => -(questionWidth + ((flightRuleStripHeight - questionWidth) / 2)))
        .attr('x', (d) => x(d.forecast_ts) - (questionWidth / 2))
        .attr('width', questionWidth)
        .attr('height', questionWidth)
        .style('display', (d) => {
          if (!d.cld && bnd3Service.getFlightDotColorForRruleset(d.frlServerValue || d.frl)
            === 'gray') {
            return 'inherit';
          }
          return 'none';
        })
        .attr('xlink:href', () => 'static/img/dot.svg');
    } else {
      const dayNightIndicatorHeight = xAxisBottomContainerHeight / 2;
      bnd3Service.drawDayNightIndicator(
        dayNightIndicatorHeight,
        dayNightIndicator,
        x,
        width,
        daysForDayNight,
      );
    }
  };
  return content;
}
export default xAxisMeteogramService();
